import { Select, SelectProps } from "antd";
import classNames from "classnames";
import { ClientPaymentStatus, PaymentStatus } from "../../api";
import styles from "./paymentStatusSelector.module.less";

const { Option } = Select;

export function getNameForPaymentStatus(status?: PaymentStatus) {
    switch (status) {
        case PaymentStatus.Paid: return "Opłacono";
        case PaymentStatus.InvoiceIssued: return "Wystawiono fakturę";
        default: return "Prognoza";
    }
}

export function getNameForClientPaymentStatus(status?: ClientPaymentStatus) {
    switch (status) {
        case ClientPaymentStatus.Paid: return "Opłacono";
        case ClientPaymentStatus.InvoiceIssued: return "Wystawiono fakturę";
        case ClientPaymentStatus.Overdue: return "Windykacja";
    }
}

export default function PaymentStatusSelector(props: PaymentStatusSelectorProps) {
    const editable = props.editable && !(props.disablePaidStatus && props.value === PaymentStatus.Paid);

    const statusClassName = (() => {
        switch (props.value) {
            case PaymentStatus.Forecast: return styles.new;
            case PaymentStatus.InvoiceIssued: return styles.inProgress;
            case PaymentStatus.Paid: return styles.done;
        }
    })();

    const className = editable ? classNames(styles.wrapper, statusClassName) : classNames(styles.wrapper, statusClassName, styles.nonEditable);

    return <Select
            dropdownMatchSelectWidth={false}
            showArrow={editable}
            disabled={!editable}
            className={className}
            {...props}>
        <Option value={PaymentStatus.Forecast} className={classNames(styles.option, styles.new)}>{getNameForPaymentStatus(PaymentStatus.Forecast)}</Option>
        <Option value={PaymentStatus.InvoiceIssued} className={classNames(styles.option, styles.inProgress)}>{getNameForPaymentStatus(PaymentStatus.InvoiceIssued)}</Option>
        <Option disabled={props.disablePaidStatus} value={PaymentStatus.Paid} className={classNames(styles.option, styles.done)}>{getNameForPaymentStatus(PaymentStatus.Paid)}</Option>
    </Select>;
}

export function ClientPaymentStatusSelector(props: PaymentStatusSelectorProps) {
    const editable = props.editable && !(props.disablePaidStatus && props.value === PaymentStatus.Paid);

    const statusClassName = (() => {
        switch (props.value) {
            case ClientPaymentStatus.Overdue: return styles.error;
            case ClientPaymentStatus.InvoiceIssued: return styles.inProgress;
            case ClientPaymentStatus.Paid: return styles.done;
        }
    })();

    const className = editable ? classNames(styles.wrapper, statusClassName) : classNames(styles.wrapper, statusClassName, styles.nonEditable);

    return <Select
            dropdownMatchSelectWidth={false}
            showArrow={editable}
            disabled={!editable}
            className={className}
            {...props}>
        <Option value={ClientPaymentStatus.InvoiceIssued} className={classNames(styles.option, styles.inProgress)}>{getNameForClientPaymentStatus(ClientPaymentStatus.InvoiceIssued)}</Option>
        <Option disabled={props.disablePaidStatus} value={ClientPaymentStatus.Paid} className={classNames(styles.option, styles.done)}>{getNameForClientPaymentStatus(ClientPaymentStatus.Paid)}</Option>
        <Option disabled={props.disablePaidStatus} value={ClientPaymentStatus.Overdue} className={classNames(styles.option, styles.done)}>{getNameForClientPaymentStatus(ClientPaymentStatus.Overdue)}</Option>
    </Select>;
}

interface PaymentStatusSelectorProps extends SelectProps {
    editable: boolean,
    disablePaidStatus?: boolean
}